import Vue                                from "vue";
import { mapGetters }                     from "vuex";
import moment                             from "moment";
import { formatDateTime, stringHelper }   from "@/components/mixins";
import { partSearch }                     from "@/components/mixins/partSearch.ts"
import {
    LoadingSpinner,
    DnRouterLink }                        from "@/components/Elements"
import { ErrorLogService, 
    RecentActivityService,
    OrderService }                        from "@/services/";
import { FeatureFlagService }             from "@/services/FeatureFlagService"
import { IRecentActivityOrderDto }        from "@/types"
import { constants }                      from "@/const";


export default Vue.extend({
    name: "RecentActivity",
    components: {
        LoadingSpinner,
        DnRouterLink
    },
    mixins: [formatDateTime, stringHelper, partSearch],

    mounted() {
        this.getRecentPartSearches();
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
            "availableDealerCodes",
            "activeAccountId"
        ])
    },
    data: () => ({
        tmsData: {},
        tmsDataIsLoading: true,
        tmsTableColumns: [
            { key: "Oem",        label: "Make"  },
            { key: "Model", label: "Model" },
            { key: "SearchDt", label: "Last Searched" }
          ],
        partSearchData: {},
        partSearchDataIsLoading: true,
        partSearchTableColumns: [
            { key: "SearchTerm",  label: "Term"  },
            { key: "OemPartCode", label: "Part Number" },
            { key: "SearchDt",  label: "Last Searched" }
          ],
        recentOrdersData: {},
        recentOrdersDataIsLoading: true,
        recentOrdersTableColumns: [
            { key: "OrderNumber",         label: "Order Number"  },
            { key: "PurchaseOrderNumber", label: "PO Number" },
            { key: "OrderDate",           label: "Order Date" },
            { key: "Status",              label: "Order Status" }
          ],
        hasClickedRecentOrders: false,
        hasClickedTms: false
    }),
    methods: {
        RecentOrdersClicked() {
            if (!this.hasClickedRecentOrders) {
                this.hasClickedRecentOrders = true;
                this.searchOrders();
            }
        },
        TmsClicked() {
            if (!this.hasClickedTms) {
                this.hasClickedTms = true;
                this.getRecentTruckModelSearches();
            }
        },
        async getRecentTruckModelSearches() {
            this.tmsDataIsLoading = true;
            try {
                let result = await RecentActivityService.getRecentTruckModelSearches(this.user.UserId);
                this.tmsData = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.tmsDataIsLoading = false;
            }
        },
        async getRecentPartSearches() {
            this.partSearchDataIsLoading = true;
            try {
                let result = await RecentActivityService.getRecentPartSearches(this.user.UserId);
                this.partSearchData = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.partSearchDataIsLoading = false;
            }
        },
        async searchOrders() {
            this.recentOrdersDataIsLoading = true;
            var tomorrow = moment().add(1,'day');
            var twoYearsAgo = moment().add(-2, 'years');

            const searchParams = {
              AccountId: this.activeAccountId,
              UserId: this.user.UserId,
              StartDate: twoYearsAgo.format("MM/DD/YYYY"),
              //using tomorrow's date as next date so that there is absolutely no chance of not retrieving orders from today
              EndDate: tomorrow.format("MM/DD/YYYY"),
              DealerCodes: [this.user.DealerCode],
              IncludeOfflineOrders: FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.OFFLINE_ORDER_PROCESSING)
            };

            OrderService.GetRecentOrderActivity(searchParams)
              .then(results => {
                this.recentOrdersData = results.data.slice(0, 10);
              })
              .catch(err => {
                ErrorLogService.LogException(err);
              })
              .finally(() => {
                this.recentOrdersDataIsLoading = false;
              });  
          },
          getOrderDetailLink(order: IRecentActivityOrderDto){
            var url = `/orders/details?orderNumber=${order.OrderNumber}&orderSource=${order.OrderSource}`
            url +=    `&dealerCode=${order.DealerCode}&salesOrg=${order.SalesOrganization}`;
            return url;
          },
          async partSearch(searchTerm: string) {
            this.partSearchDataIsLoading = true;
            try {
                let page = 1;
                let isQuerySearch = false;
                await this.searchParts(page, page, searchTerm, isQuerySearch);
            }
            catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.partSearchDataIsLoading = false;
            }
          }
    },
    watch: {
    },
});
